import * as React from 'react';
import Box from '@mui/material/Box';
import { Typography, TypographyProps } from 'src/components/Typography';
import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

export interface HeaderProps {
  children?: React.ReactNode;
  isSummaryView?: boolean;
  title?: string | JSX.Element;
  variant?: TypographyProps['variant'];
}

export const EntityHeader = ({
  children,
  isSummaryView,
  title,
  variant = 'h1',
}: HeaderProps) => {
  return (
    <Wrapper>
      {isSummaryView ? (
        <Typography variant={variant} sx={sxTypography}>
          {title}
        </Typography>
      ) : null}
      {children && (
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            borderRadius: "10px",
          }}
        >
          {children}
        </Box>
      )}
    </Wrapper>
  );
};

const Wrapper = styled('div', {
  name: 'EntityHeader',
})(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  margin: 0,
  width: '100%',
  borderRadius: "23px",
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
}));

const sxTypography = {
  whiteSpace: 'nowrap',
  padding: 1,
};
